import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class SettlementService {

	constructor(private _http: HttpClient) {
	}

	/**
	 * @api {get} /v2/HumanResources/:id/EstimatedSettlements/:beginDate/:endDate/:basedUpon Get Estimated Settlement Detail
	 * @apiName getEstimatedSettlementDetail
	 * @apiGroup HumanResources
	 * @apiVersion 20.0.0
	 */
	getEstimatedSettlementDetail(id, beginDate, endDate, basedUpon) {
		return this._http.get<any>(`${environment.apiUrl}/v2/HumanResources/${id}/EstimatedSettlements/${beginDate}/${endDate}/${basedUpon}`);
	}

	/**
	 * @api {get} /v2/HumanResources/:id/Settlements/:batchId Get Settlement Detail
	 * @apiName getSettlementDetail
	 * @apiGroup HumanResources
	 * @apiVersion 20.0.0
	 */
	getSettlementDetail(id, batchId) {
		return this._http.get<any>(`${environment.apiUrl}/v2/HumanResources/${id}/Settlements/${batchId}`);
	}

	/**
	 * @api {get} /v2/HumanResources/:id/Settlements Get Settlements
	 * @apiName getSettlements
	 * @apiGroup HumanResources
	 * @apiVersion 20.0.0
	 */
	getSettlements(id) {
		return this._http.get<any>(`${environment.apiUrl}/v2/HumanResources/${id}/Settlements`);
	}
}
